/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a quick 10-minute bodyweight circuit when you don't have time for a full workout.`)
};

const es_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer un circuito rápido de 10 minutos con el propio peso corporal cuando no tienes tiempo para un entrenamiento completo.`)
};

const de_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein schnelles 10-Minuten-Bodyweight-Zirkeltraining absolvieren, wenn keine Zeit für ein volles Workout bleibt.`)
};

const nl_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een snel bodyweight-circuit van 10 minuten draaien als je geen tijd hebt voor een volledige training.`)
};

const fr_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réaliser un circuit rapide de 10 minutes au poids du corps quand vous n’avez pas le temps pour un entraînement complet.`)
};

const it_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eseguire un rapido circuito a corpo libero di 10 minuti quando non hai tempo per un allenamento completo.`)
};

const pt_br2_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um circuito rápido de 10 minutos com o peso do corpo quando não há tempo para um treino completo.`)
};

const pt_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um circuito rápido de 10 minutos com o peso do corpo quando não há tempo para um treino completo.`)
};

const ja_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`しっかりしたワークアウトをする時間がないとき、手早く10分間の自重サーキットを行う。`)
};

const zh_timer_u10m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没时间进行完整锻炼时，快速完成一次10分钟的自重循环训练。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_use1", locale)
	if (locale === "en") return en_timer_u10m_use1(inputs)
	if (locale === "es") return es_timer_u10m_use1(inputs)
	if (locale === "de") return de_timer_u10m_use1(inputs)
	if (locale === "nl") return nl_timer_u10m_use1(inputs)
	if (locale === "fr") return fr_timer_u10m_use1(inputs)
	if (locale === "it") return it_timer_u10m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_use1(inputs)
	if (locale === "pt") return pt_timer_u10m_use1(inputs)
	if (locale === "ja") return ja_timer_u10m_use1(inputs)
	return zh_timer_u10m_use1(inputs)
};